"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickCaptureService = void 0;
const Common_1 = require("./Common");
const Logger_1 = __importStar(require("./Logger"));
const config = {
    id: [
        { strategy: "attr", fields: [Common_1.HTML_ATTR_COMPONENT_ID, Common_1.HTML_ATTR_COMPONENT_ID_LEGACY] },
        { strategy: "prop", fields: ["id"] },
    ],
    type: [
        { strategy: "attr", fields: [Common_1.HTML_ATTR_COMPONENT_TYPE, Common_1.HTML_ATTR_COMPONENT_TYPE_LEGACY] },
        { strategy: "prop", fields: ["tagName"] },
    ],
    name: [
        { strategy: "attr", fields: [Common_1.HTML_ATTR_COMPONENT_NAME, Common_1.HTML_ATTR_COMPONENT_NAME_LEGACY] },
        { strategy: "attr", tag: HTMLInputElement, type: "reset", fields: ["value"] },
        { strategy: "attr", tag: HTMLInputElement, type: "submit", fields: ["value"] },
        { strategy: "attr", tag: HTMLInputElement, type: "image", fields: ["alt", "src"] },
        { strategy: "attr", tag: HTMLInputElement, fields: ["name"] },
        { strategy: "attr", tag: HTMLSelectElement, fields: ["name"] },
        { strategy: "attr", tag: HTMLTextAreaElement, fields: ["name"] },
        { strategy: "attr", tag: HTMLImageElement, fields: ["alt", "src"] },
        { strategy: "prop", fields: ["textContent"] },
    ],
    attributes: [
        {
            strategy: "dataMap",
            fields: [Common_1.HTML_ATTR_COMPONENT_ATTR_PREFIX, Common_1.HTML_ATTR_COMPONENT_ATTR_PREFIX_LEGACY],
        },
    ],
    metrics: [
        {
            strategy: "dataMap",
            fields: [Common_1.HTML_ATTR_COMPONENT_METRIC_PREFIX, Common_1.HTML_ATTR_COMPONENT_METRIC_PREFIX_LEGACY],
        },
    ],
};
class ClickCaptureService {
    collectField(name, element, entries = []) {
        var _a;
        const elementType = (_a = element.getAttribute("type")) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        for (let i = 0; i < config[name].length; i += 1) {
            const { fields, strategy, tag, type } = config[name][i];
            if ((!tag || element instanceof tag) && (!type || type === elementType)) {
                for (let j = 0; j < fields.length; j += 1) {
                    const field = fields[j];
                    if (strategy === "attr" && !field.startsWith("data-")) {
                        Logger_1.default.warn(`Using "${field}" is deprecated, please use "data-${field}" instead`);
                    }
                    if (strategy === "prop") {
                        const value = element[field];
                        if (value)
                            return { value: value.toString() };
                    }
                    else if (strategy === "attr") {
                        const value = element.getAttribute(field);
                        if (value)
                            return { value };
                    }
                    else if (strategy === "dataMap") {
                        Array.from(element.attributes)
                            .filter((attr) => attr.name.startsWith(field))
                            .forEach((attr) => entries.unshift([attr.name.slice(field.length), attr.value]));
                    }
                }
            }
        }
        return Object.fromEntries(entries);
    }
    collectComponent(element) {
        return {
            attributes: this.collectField("attributes", element, element instanceof HTMLAnchorElement ? [["href", element.href]] : []),
            metrics: this.collectField("metrics", element),
            id: this.collectField("id", element).value,
            name: this.collectField("name", element).value,
            type: this.collectField("type", element).value,
        };
    }
    constructor(contextService) {
        this.contextService = contextService;
        this.capture = this.capture.bind(this);
    }
    /** Adds the click event listener to the document event emitter */
    connect() {
        document.addEventListener("click", this.capture);
    }
    /** Removes the click event listener from the document event emitter */
    disconnect() {
        document.removeEventListener("click", this.capture);
    }
    /** Handles the emitted click events
     * Only handles if the event target is an Element
     * Only handles if the element has the "adp-click" attribute. Value is not checked.
     */
    capture(event) {
        if (!this.contextService.context.config.captureDocumentClickEvents) {
            return;
        }
        const { target } = event;
        if (!(target instanceof HTMLElement)) {
            Logger_1.default.debug("Clicked target does not satisfy conditions for capture, not an HTMLElement", target);
            return;
        }
        if (target.hasAttribute(Common_1.HTML_ATTR_CAPTURE_CLICK)) {
            Logger_1.default.debug("Capturing click event.");
            this.contextService.tracker.track("CLICK_COMPONENT", this.collectComponent(target));
            return;
        }
        if (target.hasAttribute(Common_1.HTML_ATTR_CAPTURE_CLICK_LEGACY)) {
            Logger_1.default.warn(`Capturing click event with deprecated "${Common_1.HTML_ATTR_CAPTURE_CLICK_LEGACY}", use "${Common_1.HTML_ATTR_CAPTURE_CLICK}" instead`);
            this.contextService.tracker.track("CLICK_COMPONENT", this.collectComponent(target));
            return;
        }
        Logger_1.default.debug(`Clicked target does not satisfy conditions for capture, there is no ${Common_1.HTML_ATTR_CAPTURE_CLICK}`, target);
    }
}
__decorate([
    (0, Logger_1.logApi)()
], ClickCaptureService.prototype, "connect", null);
__decorate([
    (0, Logger_1.logApi)()
], ClickCaptureService.prototype, "disconnect", null);
exports.ClickCaptureService = ClickCaptureService;
